module.exports = __webpack_public_path__ + "DB_Corkboard_tmp-231cbb4345405c300d51c17a349cc0e8.png";